import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

interface Dish {
  category: string;
  name: string;
  description: string;
  image: string;
}

const dishes: Dish[] = [
  {
    category: 'para_llevar',
    name: '1 Kg de cochinita, relleno negro, lomo adobado o lechón',
    description: 'Incluye frijoles o sopa de lima, tortillas, cebollitas moradas, salsa de escabeche y crema de habanero.',
    image: '/img/Menuelchel/paquetellevar.JPG',
  },
  {
    category: 'extras',
    name: 'Sopa de lima de 1 lt',
    description: 'Complemento extra para acompañar tus pedidos.',
    image: '/img/sopalima.jpg',
  },
];

const categories = ['Todos', 'Para_llevar', 'Extras'];

const MenuParaLlevar: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filteredDishes = selectedCategory
    ? dishes.filter((dish) => dish.category === selectedCategory)
    : dishes;

  return (
    <div className="bg-[#05603c]">
      {/* Category navbar */}
      <nav
        className="flex flex-wrap justify-center gap-2 px-1.5 py-3 border-b-2 border-brand-dark sticky top-0 z-50 bg-gradient-brand"
      >
        {categories.map((category) => {
          const key = category.toLowerCase();
          const isActive = selectedCategory === key || (key === 'todos' && !selectedCategory);
          return (
            <button
              key={category}
              onClick={() => setSelectedCategory(key === 'todos' ? null : key)}
              className={`px-3 py-2 text-[clamp(12px,1.5vw,16px)] border-2 rounded-[5px] cursor-pointer font-bold transition-colors duration-300 ${
                isActive
                  ? 'bg-white text-brand-dark border-white'
                  : 'bg-transparent text-white border-white hover:bg-white hover:text-brand-dark'
              }`}
            >
              {category}
            </button>
          );
        })}
      </nav>

      {/* Menu grid */}
      <section className="max-w-[1200px] mx-auto px-5 py-5">
        <Helmet>
          <title>Menú Para Llevar | El Chel</title>
          <meta name="description" content="Paquetes para llevar de El Chel: cochinita pibil, relleno negro, lechón y más. Pedidos en Tlalpan, CDMX." />
        </Helmet>
        <h1 className="text-[clamp(18px,2.5vw,30px)] text-white text-center mb-5 font-bold">Menú Para Llevar</h1>

        {filteredDishes.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-2xl font-bold text-white mb-2">Sin resultados</p>
            <p className="text-brand-deep">No hay platillos en esta categoría por el momento.</p>
          </div>
        ) : (
          <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
            {filteredDishes.map((dish, index) => (
              <div
                key={index}
                className="flex flex-col items-center p-5 border-2 border-brand-deep rounded-[12px] bg-[#05603c] shadow-brand-card"
              >
                <img
                  src={dish.image}
                  alt={dish.name}
                  loading="lazy"
                  className="w-full object-cover rounded-[8px]"
                  style={{ height: 'clamp(200px,15vw,180px)' }}
                />
                <h2 className="text-[clamp(14px,1.5vw,18px)] text-white font-bold my-2.5 text-center">{dish.name}</h2>
                <p className="text-[clamp(12px,1.2vw,16px)] text-[#e65100] mb-2.5 text-center">{dish.description}</p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default MenuParaLlevar;
